import { IVec2, Vec2 } from "@base/math/Vec2";
import { ImageSource, ITexInfo, ITexInfoPattern, predefinedImageSource } from "@biz/definitions/SunSailDefinitions";
import { PredefinedMaterials } from "@biz/items/PredefinedMaterials";

export class TexInfo {
  static create(image: ImageSource = predefinedImageSource, normal: ImageSource | undefined = undefined): ITexInfo {
    if (image.type === "predefined" && PredefinedMaterials.getPredefinedMaterialById(image.id)?.type === "pattern") {
      return {
        type: "pattern",
        offset: Vec2.ZERO,
        rotation: 0,
        scale: Vec2.ONE,
        image,
        normal
      }
    } else {
      return {
        type: "image",
        area: TexInfo.createTexArea(),
        image,
        normal
      }
    }
  }

  static createTexArea(): IVec2[] {
    return [
      Vec2.from(0, 0),
      Vec2.from(1, 0),
      Vec2.from(1, 1),
      Vec2.from(0, 1),
    ]
  }

  static transformPattern(p: IVec2, texInfo: ITexInfoPattern): IVec2 {
    return Vec2.rotate(Vec2.from(texInfo.offset.x + (p.x) * texInfo.scale.x, 1 * (texInfo.offset.y + p.y) * texInfo.scale.y), texInfo.rotation)
  }
}